/* Rey Vinilo · simulador 3D de vinilado (sections/rv-simulador.liquid).
   Carga three.js (rv-sim-three.js) y el coche (rv-sim-car.glb) solo en esta página.
   Los colores salen de los productos de la tienda (JSON #rv-sim-products) y su acabado de snippets/rv-sim-spec.liquid. */
(function () {
  var root = document.querySelector('[data-rv-sim]');
  if (!root) return;
  var $ = function (s, el) { return (el || root).querySelector(s); };
  var $$ = function (s, el) { return Array.prototype.slice.call((el || root).querySelectorAll(s)); };
  var T = JSON.parse($('[data-rv-sim-text]').textContent);
  var PRODS = JSON.parse($('[data-rv-sim-products]').textContent);
  var SPEC = JSON.parse($('[data-rv-sim-spec]').textContent);
  var TEX = JSON.parse($('[data-rv-sim-tex]').textContent);
  // Carga un módulo JS con una etiqueta <script type="module">: Shopify minifica este archivo y rompe la importación dinámica (la cambia por require)
  function loadMod(url) {
    return new Promise(function (res, rej) {
      var k = '__rvMod' + Math.random().toString(36).slice(2), s = document.createElement('script'), t = setTimeout(function () { rej(new Error('timeout ' + url)); }, 60000);
      window[k] = function (m) { clearTimeout(t); delete window[k]; res(m); };
      s.type = 'module';
      s.onerror = function () { clearTimeout(t); rej(new Error('no carga ' + url)); };
      s.textContent = 'import * as m from ' + JSON.stringify(new URL(url, location.href).href) + ';window[' + JSON.stringify(k) + '](m);';
      document.head.appendChild(s);
    });
  }
  // Tamaño de cada estampado en el coche (repeticiones por metro, del tamaño real medido en las fotos del rollo), en 3D y en la foto
  var TS = { 'carbono-forjado': 3, 'carbono-forjado-oro': 3, 'carbono-forjado-plata': 3, diamante: 2, galaxia: 1.73, ajedrez: 2.2, oxido: 1.6, alcantara: 1.89, 'madera-haya': 2, 'madera-nogal': 2, 'camuflaje-pixel': 2.11, 'camuflaje-ramas': 1.89, 'camuflaje-artico': 1, 'camuflaje-arena': 2.23, 'camuflaje-clasico': 2.53, 'camuflaje-oceano': 2.86, 'camuflaje-urbano': 2, 'camuflaje-selva': 1.95, 'hellaflush-bbs-mate': 1.81, 'hellaflush-bbs-brillo': 1.8, 'hellaflush-rockstar': 1.91, 'hellaflush-blanco-negro': 1.91 };

  // ---------- lista de vinilos (sin repetir: un producto puede estar en dos gamas) ----------
  var seen = {}, list = [], gamas = [];
  PRODS.forEach(function (p) {
    var s = SPEC[p.id];
    if (!s) return;
    if (gamas.indexOf(p.g) < 0) gamas.push(p.g);
    if (seen[p.id]) { seen[p.id].gs.push(p.g); return; }
    p.s = s; p.gs = [p.g]; seen[p.id] = p; list.push(p);
  });

  var grid = $('[data-rv-sim-grid]'), chips = $('[data-rv-sim-chips]');
  function swatchBg(p) {
    var s = p.s;
    if (s.tex) return 'center/cover url(' + TEX[s.tex] + ')';
    var c = 'rgb(' + s.c.map(function (x) { return Math.round(x * 255); }).join(',') + ')';
    if (s.m === 'flip') return 'linear-gradient(135deg,' + c + ',rgb(' + s.c2.map(function (x) { return Math.round(x * 255); }).join(',') + '))';
    if (s.m.indexOf('carbon') === 0) return 'url(' + TEX.carbono + ') center/18px,' + c;
    if (s.m === 'chrome' || s.m === 'satinchrome' || s.m === 'brushed') return 'linear-gradient(135deg,' + c + ' 20%,#fff 48%,' + c + ' 75%)';
    return c;
  }
  function chip(label, val) {
    var b = document.createElement('button');
    b.type = 'button'; b.className = 'rv-sim__chip'; b.textContent = label; b.dataset.g = val;
    b.addEventListener('click', function () {
      $$('.rv-sim__chip', chips).forEach(function (x) { x.setAttribute('aria-pressed', x === b); });
      $$('.rv-sim__sw', grid).forEach(function (x) { x.hidden = val !== '' && x._p.gs.indexOf(val) < 0; });
    });
    chips.appendChild(b);
    return b;
  }
  chip(T.all, '').setAttribute('aria-pressed', 'true');
  gamas.forEach(function (g) { chip(g, g); });
  list.forEach(function (p) {
    var b = document.createElement('button');
    b.type = 'button'; b.className = 'rv-sim__sw'; b._p = p;
    b.setAttribute('aria-label', p.t); b.title = p.t;
    b.innerHTML = '<i></i>';
    b.firstChild.style.background = swatchBg(p);
    if (p.s.m.indexOf('carbon') === 0) b.firstChild.style.backgroundBlendMode = 'multiply';
    b.addEventListener('click', function () { choose(p); });
    grid.appendChild(b);
  });

  // ---------- zona: carrocería o techo y detalles ----------
  var zone = 'body', state = { body: null, accent: null, int: null };
  $$('[data-rv-sim-zone]').forEach(function (b) {
    b.addEventListener('click', function () {
      zone = b.dataset.rvSimZone;
      $$('[data-rv-sim-zone]').forEach(function (x) { x.setAttribute('aria-pressed', x === b); });
      showCard(state[zone]);
      markSel();
    });
  });

  var card = $('[data-rv-sim-card]');
  function showCard(p) {
    if (!p) { card.hidden = true; return; }
    card.hidden = false;
    $('[data-rv-sim-img]', card).src = p.img || '';
    $('[data-rv-sim-img]', card).hidden = !p.img;
    $('[data-rv-sim-title]', card).textContent = p.t;
    $('[data-rv-sim-price]', card).textContent = p.p;
    $('[data-rv-sim-link]', card).href = p.u;
  }
  // vinilo elegido: en el exterior (3D y tu foto) y en el interior, por separado
  function cur() { return mode === 'interior' ? state.int : state[zone]; }
  function markSel() {
    var c = cur();
    $$('.rv-sim__sw', grid).forEach(function (x) { x.setAttribute('aria-pressed', c === x._p); });
  }
  function choose(p) {
    if (mode === 'interior') state.int = p; else state[zone] = p;
    showCard(p); markSel();
    if (mode === '3d') { if (api) api.apply(zone, p.s); }
    else if (eng[mode]) eng[mode].apply(p.s);
  }

  // ---------- pestañas «Interior» (foto de ejemplo) y «Tu coche» (foto del cliente): assets/rv-sim-foto.js, se carga al pulsar ----------
  var mode = '3d', eng = {}, modP = null, tools = $('[data-rv-sim-tools]');
  var wraps = { foto: $('[data-rv-sim-photo]'), interior: $('[data-rv-sim-int]') };
  function fotoMod() {
    if (modP) return modP;
    modP = loadMod(root.dataset.foto);
    modP.catch(function (e) { modP = null; if (window.console) console.warn('rv-sim foto', e); });
    return modP;
  }
  function engine(k) {
    return fotoMod().then(function (m) {
      if (eng[k]) return eng[k];
      var d = root.dataset, w = wraps[k];
      eng[k] = m.init({
        load: loadMod, wrap: w, canvas: $('canvas', w), status: $('[data-rv-sim-pstatus]', w), tex: TEX, ts: TS, t: T,
        urls: {
          bundle: d.mpBundle || 'https://cdn.jsdelivr.net/npm/@mediapipe/tasks-vision@0.10.21/vision_bundle.mjs',
          wasm: d.mpWasm || 'https://cdn.jsdelivr.net/npm/@mediapipe/tasks-vision@0.10.21/wasm',
          model: d.mpModel || 'https://storage.googleapis.com/mediapipe-models/image_segmenter/deeplab_v3/float32/1/deeplab_v3.tflite',
          // SAM para afinar silueta, lunas, ruedas y «Rellenar pieza» (data-sam="off" lo quita)
          tf: d.sam === 'off' ? '' : (d.tf || 'https://cdn.jsdelivr.net/npm/@huggingface/transformers@3.0.2/dist/transformers.min.js'),
          sam: d.samModel || 'Xenova/slimsam-77-uniform'
        }
      });
      return eng[k];
    });
  }
  function resetBrush() { $$('[data-rv-sim-brush]').forEach(function (x) { x.setAttribute('aria-pressed', 'false'); }); }
  function setMode(m) {
    if (eng[mode]) eng[mode].brush('');
    resetBrush();
    mode = m;
    root.classList.toggle('is-foto', m !== '3d');
    root.dataset.mode = m;
    $$('[data-rv-sim-mode]').forEach(function (b) { b.setAttribute('aria-pressed', b.dataset.rvSimMode === m); });
    wraps.foto.hidden = m !== 'foto';
    if (wraps.interior) wraps.interior.hidden = m !== 'interior';
    $('[data-rv-sim-priv]').hidden = m !== 'foto';
    tools.hidden = m === '3d' || (m === 'foto' && !(eng.foto && eng.foto.hasPhoto()));
    if (m === 'foto') {
      $$('[data-rv-sim-zone=body]').forEach(function (b) { b.click(); });   // en la foto solo hay carrocería
      engine('foto');
    } else if (m === 'interior') {
      if (!state.int) state.int = list.filter(function (p) { return String(p.id) === root.dataset.intDefault; })[0] || state.body;
      engine('interior').then(function (e) {
        var go = function () { if (state.int) e.apply(state.int.s); };
        if (e.hasPhoto()) go(); else e.openUrl(root.dataset.intImg, root.dataset.intMask, go, +root.dataset.intFlat || 0);
      });
    } else if (api) { api.resize(); if (state.body) api.apply('body', state.body.s); }
    showCard(cur()); markSel();
  }
  $$('[data-rv-sim-mode]').forEach(function (b) { b.addEventListener('click', function () { setMode(b.dataset.rvSimMode); }); });
  $$('[data-rv-sim-file]').forEach(function (inp) {
    inp.addEventListener('change', function () {
      var f = inp.files && inp.files[0];
      if (!f) return;
      engine('foto').then(function (fm) {
        fm.open(f);
        tools.hidden = false;
        if (state.body) fm.apply(state.body.s);
        inp.value = '';
      });
    });
  });
  $$('[data-rv-sim-brush]').forEach(function (b) {
    b.addEventListener('click', function () {
      var e = eng[mode];
      if (!e) return;
      var m = e.brush(b.dataset.rvSimBrush);
      $$('[data-rv-sim-brush]').forEach(function (x) { x.setAttribute('aria-pressed', x.dataset.rvSimBrush === m); });
    });
  });
  var orig = $('[data-rv-sim-orig]');
  if (orig) {
    var on = function (e) { e.preventDefault(); if (eng[mode]) eng[mode].original(true); };
    var off = function () { if (eng[mode]) eng[mode].original(false); };
    orig.addEventListener('pointerdown', on);
    ['pointerup', 'pointerleave', 'pointercancel'].forEach(function (ev) { orig.addEventListener(ev, off); });
  }
  if (location.search.indexOf('rvshot') > -1) window.rvSimEng = eng;

  // ---------- 3D ----------
  var api = null, stage = $('[data-rv-sim-stage]'), bar = $('[data-rv-sim-bar]'), msg = $('[data-rv-sim-msg]');
  function fail(e) { if (e && window.console) console.warn('rv-sim', e); msg.textContent = T.nogl; msg.hidden = false; bar.parentNode.hidden = true; }
  try {
    var t = document.createElement('canvas');
    if (!(t.getContext('webgl2') || t.getContext('webgl'))) return fail();
  } catch (e) { return fail(); }

  loadMod(root.dataset.three).then(function (THREE) { start(THREE); }).catch(fail);

  function start(THREE) {
    var W = stage.clientWidth, H = stage.clientHeight;
    var renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true, preserveDrawingBuffer: location.search.indexOf('rvshot') > -1 });
    renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, 2));
    renderer.setSize(W, H);
    renderer.toneMapping = THREE.NeutralToneMapping;
    renderer.toneMappingExposure = 1.0;
    stage.appendChild(renderer.domElement);

    var scene = new THREE.Scene();
    var pmrem = new THREE.PMREMGenerator(renderer);
    scene.environment = pmrem.fromScene(studio(), 0.02).texture;
    scene.environmentIntensity = 1.0;

    // Estudio de fotos para los reflejos: sala oscura con cajas de luz (techo, laterales y fondo) para que brillo y cromado se lean bien
    function studio() {
      var env = new THREE.Scene(), box = new THREE.BoxGeometry(1, 1, 1);
      var room = new THREE.Mesh(box, new THREE.MeshBasicMaterial({ color: new THREE.Color(0.16, 0.16, 0.17), side: THREE.BackSide }));
      room.scale.set(30, 14, 30); room.position.y = 6; env.add(room);
      var floor = new THREE.Mesh(box, new THREE.MeshBasicMaterial({ color: new THREE.Color(0.32, 0.32, 0.33) }));
      floor.scale.set(30, 0.1, 30); floor.position.y = -0.9; env.add(floor);
      function light(i, sx, sy, sz, x, y, z) {
        var m = new THREE.Mesh(box, new THREE.MeshBasicMaterial({ color: new THREE.Color(i, i, i) }));
        m.scale.set(sx, sy, sz); m.position.set(x, y, z); env.add(m);
      }
      light(5, 16, 0.1, 3.2, 0, 12.8, 0);      // franja del techo a lo largo
      light(3, 16, 0.1, 1.2, 0, 12.8, 4.5);
      light(3, 16, 0.1, 1.2, 0, 12.8, -4.5);
      light(2.6, 0.1, 4, 12, 14.8, 6, 0);       // laterales
      light(2.6, 0.1, 4, 12, -14.8, 6, 0);
      light(1.6, 12, 3, 0.1, 0, 5, 14.8);       // fondo
      light(1.6, 12, 3, 0.1, 0, 5, -14.8);
      return env;
    }
    var camera = new THREE.PerspectiveCamera(32, W / H, 0.1, 100);
    var controls = new THREE.OrbitControls(camera, renderer.domElement);
    controls.enableDamping = true; controls.enablePan = false;
    controls.minPolarAngle = 0.35; controls.maxPolarAngle = 1.52;
    var shot = !!root.dataset.shot || location.search.indexOf('rvshot') > -1;
    controls.autoRotate = !shot; controls.autoRotateSpeed = 0.6;
    controls.addEventListener('start', function () { controls.autoRotate = false; });

    var texLoader = new THREE.TextureLoader(), texCache = {};
    function getTex(name) {
      if (!texCache[name]) {
        var tx = texLoader.load(TEX[name], function () { dirty = 2; });
        tx.wrapS = tx.wrapT = THREE.RepeatWrapping; tx.colorSpace = THREE.SRGBColorSpace;
        tx.anisotropy = 8;
        texCache[name] = tx;
      }
      return texCache[name];
    }

    // Material de vinilo: mapeo triplanar (los estampados siguen la carrocería sin depender de sus UV)
    // y efecto camaleón (color 1 → color 2 según el ángulo).
    function vinyl(s, flakes) {
      var m = new THREE.MeshPhysicalMaterial();
      var u = { uTri: { value: null }, uTriS: { value: 1 }, uTriOn: { value: 0 }, uTriG: { value: 1 }, uFlip: { value: 0 }, uCol2: { value: new THREE.Color() } };
      m.userData.u = u;
      m.onBeforeCompile = function (sh) {
        Object.assign(sh.uniforms, u);
        sh.vertexShader = sh.vertexShader
          .replace('#include <common>', '#include <common>\nvarying vec3 vTriP;\nvarying vec3 vTriN;')
          .replace('#include <fog_vertex>', '#include <fog_vertex>\nvTriP=(modelMatrix*vec4(transformed,1.0)).xyz;\nvTriN=normalize(mat3(modelMatrix)*objectNormal);');
        sh.fragmentShader = sh.fragmentShader
          .replace('#include <common>', '#include <common>\nvarying vec3 vTriP;\nvarying vec3 vTriN;\nuniform sampler2D uTri;\nuniform float uTriS;\nuniform float uTriOn;\nuniform float uTriG;\nuniform float uFlip;\nuniform vec3 uCol2;')
          .replace('#include <map_fragment>', [
            '#include <map_fragment>',
            'if(uFlip>0.5){float fr=1.0-abs(dot(normalize(vNormal),normalize(vViewPosition)));diffuseColor.rgb=mix(diffuseColor.rgb,uCol2,smoothstep(0.15,0.85,fr));}',
            'if(uTriOn>0.5){vec3 w=pow(abs(normalize(vTriN)),vec3(6.0));w/=(w.x+w.y+w.z);',
            'vec3 tc=texture2D(uTri,vTriP.zy*uTriS).rgb*w.x+texture2D(uTri,vTriP.xz*uTriS).rgb*w.y+texture2D(uTri,vTriP.xy*uTriS).rgb*w.z;',
            'diffuseColor.rgb*=pow(tc,vec3(2.2))*uTriG;}'
          ].join('\n'));
      };
      m.customProgramCacheKey = function () { return 'rvvinyl'; };
      m.userData.flakes = flakes;
      setVinyl(m, s);
      return m;
    }
    var P = {
      gloss: { r: 0.18, cc: 1, ccr: 0.03, met: 0 },
      matte: { r: 0.78, cc: 0, ccr: 0, met: 0 },
      satin: { r: 0.45, cc: 0.3, ccr: 0.45, met: 0 },
      metallic: { r: 0.32, cc: 1, ccr: 0.04, met: 0.6, flakes: 1 },
      pearl: { r: 0.22, cc: 1, ccr: 0.03, met: 0.1, iri: 0.5 },
      chrome: { r: 0.03, cc: 0, ccr: 0, met: 1 },
      satinchrome: { r: 0.3, cc: 0, ccr: 0, met: 1 },
      brushed: { r: 0.34, cc: 0, ccr: 0, met: 1, an: 0.8 },
      flip: { r: 0.25, cc: 1, ccr: 0.03, met: 0.35, flakes: 1 },
      carbon3d: { r: 0.4, cc: 0.5, ccr: 0.3, met: 0, tri: 'carbono', ts: 6.5, g: 2.6 },
      carbon_gloss: { r: 0.3, cc: 1, ccr: 0.02, met: 0, tri: 'carbono', ts: 7, g: 2.6 }
    };
    // Tamaño de cada estampado en el coche (repeticiones por metro)
    function setVinyl(m, s) {
      var p = P[s.m] || P.gloss, u = m.userData.u;
      m.color.setRGB(s.c[0], s.c[1], s.c[2], THREE.SRGBColorSpace);
      m.roughness = p.r; m.metalness = p.met; m.clearcoat = p.cc; m.clearcoatRoughness = p.ccr;
      m.iridescence = p.iri || 0; m.iridescenceIOR = 1.6; m.iridescenceThicknessRange = [200, 500];
      m.anisotropy = p.an || 0; m.anisotropyRotation = 0;
      m.normalMap = p.flakes ? m.userData.flakes : null; m.normalScale.set(0.25, 0.25);
      u.uFlip.value = s.m === 'flip' ? 1 : 0;
      if (s.c2) u.uCol2.value.setRGB(s.c2[0], s.c2[1], s.c2[2], THREE.SRGBColorSpace);
      var tri = s.tex || p.tri;
      u.uTriOn.value = tri ? 1 : 0;
      if (tri) { u.uTri.value = getTex(tri); u.uTriS.value = s.tex ? (TS[s.tex] || 1.1) : p.ts; u.uTriG.value = p.g && !s.tex ? p.g : 1; }
      // carbono negro: un poco más claro para que se vea la trama
      if (p.g && !s.tex) m.color.setRGB(Math.max(s.c[0], 0.11), Math.max(s.c[1], 0.11), Math.max(s.c[2], 0.115), THREE.SRGBColorSpace);
      if (!tri) u.uTri.value = null; // (antes se borraba también la textura de los estampados y salían negros)
      if (s.tex) m.color.setRGB(1, 1, 1);
      m.needsUpdate = true;
      dirty = 2;
    }

    var mats = {}, dirty = 2;
    var loader = new THREE.GLTFLoader();
    loader.setMeshoptDecoder(THREE.MeshoptDecoder);
    if (root.dataset.draco) loader.setDRACOLoader(new THREE.DRACOLoader().setDecoderPath(root.dataset.draco).setDecoderConfig({ type: 'js' }));
    // Materiales de la pintura: el del modelo puede llamarse distinto (data-body-mat, separados por comas)
    var BODY = (root.dataset.bodyMat || 'RV_Body').split(','), ACC = (root.dataset.accentMat || 'RV_Accent').split(',');
    loader.load(root.dataset.model, function (gltf) {
      var car = gltf.scene, flakes = null, aoTex = null, hasAcc = false;
      car.traverse(function (o) {
        if (!o.isMesh) return;
        var n = o.material && o.material.name;
        if (BODY.indexOf(n) > -1 || ACC.indexOf(n) > -1) {
          flakes = flakes || o.material.normalMap; aoTex = aoTex || o.material.aoMap;
        }
      });
      var defBody = { m: 'gloss', c: [0.42, 0.43, 0.44] }, defAcc = { m: 'gloss', c: [0.03, 0.03, 0.035] };
      mats.body = vinyl(defBody, flakes); mats.accent = vinyl(defAcc, flakes);
      [mats.body, mats.accent].forEach(function (m) { m.aoMap = aoTex; m.aoMapIntensity = 1; });
      car.traverse(function (o) {
        if (!o.isMesh) return;
        var n = o.material && o.material.name;
        if (BODY.indexOf(n) > -1) o.material = mats.body;
        else if (ACC.indexOf(n) > -1) { o.material = mats.accent; hasAcc = true; }
      });
      // sin zona de techo y detalles en el modelo: se quitan los botones de zona
      if (!hasAcc) { var zb = $('.rv-sim__zones'); if (zb) { zb.hidden = true; if (zb.previousElementSibling) zb.previousElementSibling.hidden = true; } }
      // centrar el coche sobre el suelo
      var box = new THREE.Box3().setFromObject(car), sz = box.getSize(new THREE.Vector3());
      // a escala real (unos 4,6 m de largo), venga el modelo en metros o en centímetros
      car.scale.multiplyScalar(4.6 / Math.max(sz.x, sz.z)); car.updateMatrixWorld(true);
      box.setFromObject(car); sz = box.getSize(new THREE.Vector3());
      var c = box.getCenter(new THREE.Vector3());
      car.position.set(-c.x, -box.min.y, -c.z);
      scene.add(car);
      // sombra de contacto (degradado radial)
      var cv = document.createElement('canvas'); cv.width = cv.height = 128;
      var g = cv.getContext('2d'), gr = g.createRadialGradient(64, 64, 6, 64, 64, 64);
      gr.addColorStop(0, 'rgba(0,0,0,.55)'); gr.addColorStop(0.55, 'rgba(0,0,0,.28)'); gr.addColorStop(1, 'rgba(0,0,0,0)');
      g.fillStyle = gr; g.fillRect(0, 0, 128, 128);
      var long = Math.max(sz.x, sz.z), alongX = sz.x > sz.z;
      var sh = new THREE.Mesh(new THREE.PlaneGeometry(alongX ? long * 1.25 : sz.x * 1.6, alongX ? sz.z * 1.6 : long * 1.25),
        new THREE.MeshBasicMaterial({ map: new THREE.CanvasTexture(cv), transparent: true, depthWrite: false }));
      sh.rotation.x = -Math.PI / 2; sh.position.y = 0.005; scene.add(sh);

      R = long; CY = sz.y * 0.42; carLongX = alongX;
      controls.target.set(0, CY, 0);
      controls.minDistance = long * 0.9; controls.maxDistance = long * 3;
      view(root.dataset.view || '34', true);
      bar.parentNode.hidden = true;
      root.classList.add('is-ready');
      if (state.body) setVinyl(mats.body, state.body.s);
      if (state.accent) setVinyl(mats.accent, state.accent.s);
      if (shot) window.rvSimApi = api;
    }, function (e) {
      if (e.total) bar.style.width = Math.round(e.loaded / e.total * 100) + '%';
    }, fail);

    var R = 5, CY = 0.5, carLongX = true;
    // Vistas: ángulo alrededor del coche (0 = lateral)
    var VIEWS = { side: [0, 0.08], '34': [-0.62, 0.2], front: [-1.5708, 0.12], rear: [1.5708, 0.14], top: [-0.5, 0.95] };
    function view(k, now) {
      var v = VIEWS[k] || VIEWS['34'], d = R * (W / H < 1 ? 2.1 : 1.45);
      var a = v[0] + (carLongX ? 0 : Math.PI / 2) + (parseFloat(root.dataset.turn) || 0);
      var to = new THREE.Vector3(Math.sin(a) * Math.cos(v[1]) * d, CY + Math.sin(v[1]) * d, Math.cos(a) * Math.cos(v[1]) * d);
      if (now) { camera.position.copy(to); controls.update(); dirty = 2; return; }
      anim = { from: camera.position.clone(), to: to, t: 0 };
      controls.autoRotate = false;
    }
    var anim = null;
    $$('[data-rv-sim-view]').forEach(function (b) { b.addEventListener('click', function () { view(b.dataset.rvSimView); }); });

    api = {
      apply: function (z, s) { if (mats[z]) setVinyl(mats[z], s); },
      view: function (k) { view(k, true); },
      resize: resize
    };

    var visible = true;
    if ('IntersectionObserver' in window) new IntersectionObserver(function (e) { visible = e[0].isIntersecting; }).observe(stage);
    function resize() {
      W = stage.clientWidth; H = stage.clientHeight;
      if (!W || !H) return;
      renderer.setSize(W, H); camera.aspect = W / H; camera.updateProjectionMatrix(); dirty = 2;
    }
    window.addEventListener('resize', resize);
    controls.addEventListener('change', function () { dirty = 2; });
    (function loop() {
      requestAnimationFrame(loop);
      if (!visible) return;
      if (anim) {
        anim.t = Math.min(1, anim.t + 0.04);
        var k = anim.t * anim.t * (3 - 2 * anim.t);
        camera.position.lerpVectors(anim.from, anim.to, k);
        if (anim.t >= 1) anim = null;
        dirty = 2;
      }
      controls.update();
      if (controls.autoRotate) dirty = 2;
      if (dirty > 0) { renderer.render(scene, camera); dirty--; }
    })();
  }

  // Vinilo elegido por defecto (ajuste de la sección): el primero de la lista si no hay
  var def = list.filter(function (p) { return String(p.id) === root.dataset.default; })[0];
  if (def) choose(def);
})();
